export default "__VITE_ASSET__BXSfytR2__"